export default function Testimonials() {
  const testimonials = [
    {
      quote: 'TeamPro transformed how we manage equipment orders. We went from constant coordination headaches to complete automation. The real-time tracking is game-changing.',
      name: 'Michael Richardson',
      title: 'Athletic Director',
      team: 'State University',
      image: 'https://public.readdy.ai/ai/img_res/fdbff5036b3e61fe052b765e6b984417.jpg'
    },
    {
      quote: 'The automated ordering system has reduced our equipment management time by 40%. We can now focus on coaching instead of tracking orders. It is worth every penny.',
      name: 'Sarah Chen',
      title: 'Head Coach',
      team: 'Lincoln High School',
      image: 'https://readdy.ai/api/search-image?query=professional%20female%20head%20coach%20in%20athletic%20coaching%20attire%20standing%20in%20high%20school%20gymnasium%2C%20confident%20expert%20portrait%20with%20basketball%20court%20visible%20in%20background%2C%20natural%20lighting%2C%20realistic%20sports%20photography%20style%2C%20professional%20appearance&width=400&height=500&seq=testimonial-head-coach-2&orientation=portrait'
    },
    {
      quote: 'Our equipment tracking and inventory management have never been more precise. We are making smarter decisions on purchases and never run out of critical gear. This platform is essential.',
      name: 'David Martinez',
      title: 'Equipment Manager',
      team: 'Metro Sports Academy',
      image: 'https://readdy.ai/api/search-image?query=professional%20male%20equipment%20manager%20in%20athletic%20department%20polo%20shirt%20standing%20in%20organized%20sports%20equipment%20storage%20room%2C%20experienced%20professional%20portrait%20with%20shelves%20of%20sports%20gear%20visible%20in%20background%2C%20natural%20lighting%2C%20realistic%20corporate%20photography%20style&width=400&height=500&seq=testimonial-equipment-manager-3&orientation=portrait'
    }
  ];

  return (
    <section id="testimonials" className="bg-white py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">What Teams Are Saying</h2>
          <p className="text-xl text-gray-600">Real results from athletic directors and coaches</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-8 flex flex-col shadow-xl">
              <div className="flex items-start gap-6 mb-6">
                <div className="w-20 h-24 rounded-2xl overflow-hidden flex-shrink-0 shadow-lg bg-gray-700">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1">
                  <h4 className="text-white text-lg font-bold mb-1">{testimonial.name}</h4>
                  <p className="text-gray-300 text-sm mb-1">{testimonial.title}</p>
                  <p className="text-teal-400 text-sm font-semibold">{testimonial.team}</p>
                </div>
              </div>

              <div className="flex-1">
                <div className="text-5xl text-amber-300 mb-3 leading-none">"</div>
                <p className="text-white text-lg leading-relaxed">
                  {testimonial.quote}
                </p>
              </div>

              <div className="mt-6 pt-6 border-t border-white/10">
                <button className="px-6 py-3 bg-teal-500 text-white text-sm font-semibold rounded-full hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer w-full">
                  Read Case Study
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
